import styled from "styled-components";

const ColorSelector = styled.button`
    width: 24px;
    height: 24px;
    position: relative;
    background-color: ${props => props.color};
    border: 1px solid ${props => props.color};
    border-radius: 50%;
    outline: none;
    opacity: ${props => props.opacity};

    &:hover,
    &:focus,
    &.selected {
      border-color: ${({theme}) => theme.colors.black};
      box-shadow: inset 0 0 0 4px ${({theme}) => theme.colors.white};
    }
        
`;

export default ColorSelector;